export default {
  fields: {
    country: 'País del banco',
    iban: 'IBAN',
    routing_number: 'Número de ruta',
    account_number: 'Número de cuenta',
    sort_code: 'Código de sucursal (sort code)',
    account_type: 'Tipo de cuenta',
  },
  help: {
    country: 'El país del banco, que puede ser distinto del del restaurante.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code y número de cuenta',
      description: 'La forma habitual de introducir una cuenta del Reino Unido.',
    },
    iban: {
      title: 'IBAN',
      description: 'El número de cuenta bancaria internacional.',
    },
    us_local: {
      title: 'Ruta y número de cuenta',
      description: 'Una cuenta bancaria de EE. UU.',
    },
  },
  account_types: {
    checking: 'Cuenta corriente',
    savings: 'Cuenta de ahorros',
  },
  actions: {
    save: 'Guardar cuenta bancaria',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  card: {
    account: 'Cuenta',
    country: 'País',
    status: 'Estado',
  },
  statuses: {
    active: 'Activa',
    pending_verification: 'En verificación',
    action_needed: 'Acción necesaria',
    errored: 'Pago fallido',
    missing: 'Falta',
  },
  notes: {
    pending_verification:
      'Adyen verifica cada cuenta bancaria antes de iniciar los pagos. Confírmala en la página de Adyen con un acceso bancario o un extracto bancario.',
    action_needed:
      'El proveedor de pagos no pudo confirmar esta cuenta bancaria. Revisa los datos o introduce otra cuenta.',
    errored: 'Un pago a esta cuenta ha fallado y los pagos están en pausa. Revisa los datos o introduce otra cuenta.',
  },
};
